import React from 'react';

import DynamicImportComponent from 'components/ui/DynamicImportComponent';

const IndexPage = props => (
  <DynamicImportComponent load={() => import('pages/IndexPage')}>
    {Component => (Component === null
      ? <div />
      : <Component {...props} />)}
  </DynamicImportComponent>
);

const AboutPage = props => (
  <DynamicImportComponent load={() => import('pages/AboutPage')}>
    {Component => (Component === null
      ? <div />
      : <Component {...props} />)}
  </DynamicImportComponent>
);

const CaseDetailPage = props => (
  <DynamicImportComponent load={() => import('pages/CaseDetailPage')}>
    {Component => (Component === null
      ? <div />
      : <Component {...props} />)}
  </DynamicImportComponent>
);

const CaseOverviewPage = props => (
  <DynamicImportComponent load={() => import('pages/CaseOverviewPage')}>
    {Component => (Component === null
      ? <div />
      : <Component {...props} />)}
  </DynamicImportComponent>
);

const ContactPage = props => (
  <DynamicImportComponent load={() => import('pages/ContactPage')}>
    {Component => (Component === null
      ? <div />
      : <Component {...props} />)}
  </DynamicImportComponent>
);

const ProcessPage = props => (
  <DynamicImportComponent load={() => import('pages/ProcessPage')}>
    {Component => (Component === null
      ? <div />
      : <Component {...props} />)}
  </DynamicImportComponent>
);

export {
  IndexPage, AboutPage, CaseDetailPage, CaseOverviewPage,
  ContactPage, ProcessPage,
};



// WEBPACK FOOTER //
// ./src/pages/index.js